import { submit } from "../history-manager";

/**
 * Search filters
 */

export default function searchFilters(el, props) {
  const selects = el.querySelectorAll("select");

  for (let i = 0; i < selects.length; ++i) {
    selects[i].addEventListener("change", function() {
      const cancelled = submit(el);
      if (!cancelled) {
        el.submit();
      }
    });
  }
}
